'use client';

/* Original VHire mark — red badge with a white check (brand constant in both themes) */

interface LogoProps {
  size?: number;
}

export function Logo({ size = 24 }: LogoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-label="VHire" style={{ display: 'block' }}>
      <circle cx="50" cy="50" r="47" fill="#d43a3a"/>
      <path d="M31 51 L44 65 L72 33" fill="none" stroke="#fff" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/* Full lockup — red mark + "VHire" wordmark (vector). Wordmark uses currentColor so it adapts to theme. */

interface LogoLockupProps {
  height?: number;
}

export function LogoLockup({ height = 26 }: LogoLockupProps) {
  return (
    <svg height={height} viewBox="112 210 258 80" aria-label="VHire" style={{ display: 'block', width: 'auto' }}>
      <g transform="translate(332.1555483266746 252.75)" fill="currentColor">
        <path d="M-97.30-22.22L-111.20 19.30L-116.30 19.30L-129.95-22.22L-125.69-22.22L-113.66 15.01L-101.48-22.22L-97.30-22.22Z"/>
        <path d="M-61.12 19.30L-65.17 19.30L-65.17-0.35L-85.39-0.35L-85.39 19.30L-89.44 19.30L-89.44-22.22L-85.39-22.22L-85.39-4.04L-65.17-4.04L-65.17-22.22L-61.12-22.22L-61.12 19.30Z"/>
        <path d="M-36.69 15.73L-36.69 19.30L-52.12 19.30L-52.12 15.73L-46.45 15.73L-46.45-18.68L-52.12-18.68L-52.12-22.22L-36.69-22.22L-36.69-18.68L-42.40-18.68L-42.40 15.73L-36.69 15.73Z"/>
        <path d="M0.63 19.30L-4.23 19.30L-14.85 1.72L-23.58 1.72L-23.58 19.30L-27.63 19.30L-27.63-22.22L-15.84-22.22Q-12.42-22.22-9.83-21.62Q-7.23-21.02-5.46-19.66Q-3.69-18.29-2.79-16.09Q-1.89-13.88-1.89-10.67L-1.89-10.67Q-1.89-7.91-2.47-5.89Q-3.06-3.86-4.18-2.45Q-5.31-1.04-6.94-0.18Q-8.58 0.67-10.68 1.12L-10.68 1.12L0.63 19.30ZM-6.21-10.49L-6.21-10.49Q-6.21-12.68-6.72-14.23Q-7.23-15.77-8.37-16.75Q-9.51-17.72-11.36-18.17Q-13.20-18.62-15.90-18.62L-15.90-18.62L-23.58-18.62L-23.58-1.91L-16.08-1.91Q-13.26-1.91-11.37-2.37Q-9.48-2.84-8.34-3.86Q-7.20-4.88-6.70-6.52Q-6.21-8.15-6.21-10.49Z"/>
        <path d="M33.31 19.30L8.73 19.30L8.73-22.22L33.31-22.22L33.31-18.56L12.78-18.56L12.78-4.55L30.43-4.55L30.43-0.86L12.78-0.86L12.78 15.61L33.31 15.61L33.31 19.30Z"/>
      </g>
      <g transform="translate(150.12577727554134 250) scale(0.6926000957530233) translate(-50 -50)">
        <circle cx="49.996" cy="50" r="47.5" fill="#d43a3a"/>
        <path d="M31 51 L44 65 L72 33" fill="none" stroke="#fff" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  );
}

export default Logo;
